export default {
    name: "To Do List",
    path: "/toDoList/toDoList",
    meta: {
        icon: "speaker_notes",
        auth: true
    },
    departmentName: "Dashboard",
    finalPagePermision: "",

    component: require("../component/view/toDoList/toDoList.vue")
};


// WEBPACK FOOTER //
// ./src/sidebar/toDoList.js